import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { MotivationFullDetails, TextPartData } from 'src/app/all-motivations/model/all-motivations.interface';
import { BaseComponent } from 'src/app/moov-common/base/base.component';
import { AbstractMotivationsService } from 'src/app/moov-common/services/motivation/motivations.abstract.service';
import { NAVIGATION_ROUTES } from 'src/app/navigation-routes.const';

@Component({
  selector: 'app-motivation-partial-view',
  templateUrl: './motivation-partial-view.component.html',
  styleUrls: ['./motivation-partial-view.component.scss']
})
export class MotivationPartialViewComponent
  extends BaseComponent
  implements OnInit {
  motivationDetails : MotivationFullDetails;
  imageRootFolder = 'assets/motivations/';
  descriptionTextParts: TextPartData[];
  
  constructor(private readonly motivationsService: AbstractMotivationsService, 
              private router: Router, 
              @Inject(MAT_DIALOG_DATA) public data: {selectedMotivationId: string, isRTL: boolean, isSelf: boolean},
              private dialogRef: MatDialogRef<MotivationPartialViewComponent>) {
    super();
    this.descriptionTextParts = []; 
   }

  ngOnInit(): void {
    super.ngOnInit();
    // console.log('motivationBiewComp id is'+this.data.id);
    this.getMotivation(this.data.selectedMotivationId);  
  }

  ngAfterViewInit() {
    
  }

  getMotivation(id:string):void{
    this.motivationsService.getMotivation(id).subscribe(motivationDetails => {

      if (motivationDetails == undefined){
        return;
      }

      this.motivationDetails = motivationDetails;
      this.analytics.specficMotivationPage(this.motivationDetails.id);

      if ( this.motivationDetails.longDescription == undefined || this.motivationDetails.longDescriptionPlural == undefined){
        return;
      }

      let descriptionLines:string[] = [];
      if (this.data.isSelf){
        descriptionLines = this.motivationDetails.longDescription.split("\n");
      }
      else{
        descriptionLines = this.motivationDetails.longDescriptionPlural.split("\n");
      }
      
      for (let currLine of descriptionLines){
        let textData = new TextPartData();

        if (currLine.includes('**')){
          // this is a header
          textData.isHeader = true;
          textData.text = currLine.replace(/\*\*/g, '');
        }
        else{
          textData.isHeader = false;
          textData.text = currLine;
        }

        this.descriptionTextParts.push(textData);
      }
    })
  }

  expandMotivation(): void{

    this.router.navigate( [NAVIGATION_ROUTES.app.allMotivationsView]);
    this.dialogRef.close();
  }


}
